import { format, parseISO } from "date-fns";
import { deliveryModerationChipStatus } from "../deliveryModeration";
import { isOrphanId } from "./ads";

const LAUNCH_STATUS_LABEL = {
  ready: "Ready",
  scheduled: "Scheduled",
  queued: "Queued",
  processing: "Processing",
  success: "Success",
  failed: "Failed",
  cancelled: "Cancelled",
};

const MODERATION_LABEL = {
  final_approved: "Final approved",
  final_rejected: "Final rejected",
  moderation_approved: "Approved",
  moderation_rejected: "Rejected",
  pending: "Pending",
};

/** yyyy-MM-dd, so the column sorts as a date in the sheet. */
const exportDate = (iso) => {
  if (!iso) return "";
  try {
    return format(parseISO(iso), "yyyy-MM-dd");
  } catch {
    return "";
  }
};

/** Excel columns for the Ad Launch export. */
const AD_LAUNCH_EXPORT_COLUMNS = [
  { header: "Parent Id", value: (r) => (isOrphanId(r.ad_id) ? "" : r.ad_id) },
  { header: "Launch ready date", value: (r) => exportDate(r.finalized_at) },
  { header: "Launch date", value: (r) => r.launch_date ?? "" },
  { header: "Agency", value: (r) => r.agency_name ?? "" },
  { header: "Category", value: (r) => r.category ?? "" },
  { header: "Account", value: (r) => r.account ?? "" },
  { header: "Adset Name", value: (r) => r.adset_name ?? "" },
  { header: "Ad Name", value: (r) => r.hook_name || r.delivery_ad_name || "" },
  { header: "Drive link", value: (r) => r.asset_url ?? "" },
  {
    header: "Moderation Status",
    value: (r) => MODERATION_LABEL[deliveryModerationChipStatus(r)] ?? "",
  },
  {
    header: "Status",
    value: (r) =>
      LAUNCH_STATUS_LABEL[(r.status || "").toLowerCase()] ?? r.status ?? "",
  },
];

export default AD_LAUNCH_EXPORT_COLUMNS;
